import React, { useRef, useEffect, useState } from 'react'
import {
  AppBar,
  Toolbar,
  Box,
  Container,
  Typography,
  Divider,
  TextField,
  Button,
} from '@mui/material'
import logo from '../assets/ml-logo.png'
import { TbEdit } from 'react-icons/tb'
import Services from '../services/Services'

const MalKabulTeslimi = () => {
  // — URL’den gelen parametreleri oku —
  const params = new URLSearchParams(window.location.search)
  const qrIds = params.get('ids')?.split(',') || []
  const qrPorterID = params.get('porterID') || ''
  const qrIsFood = params.get('isFood') === '1'
  const qrRecycling = params.get('recycling') === '1'
  const qrTotalCount = Number(params.get('acceptGoodsTotalCount') || 0)
  const rawObjects = params.get('objects') || ''
  let initialObjects = []
  try {
    initialObjects = rawObjects
      ? JSON.parse(decodeURIComponent(rawObjects))
      : []
  } catch (e) {
    console.error('Geçersiz objects JSON', e)
  }

  // — State ve ref’ler —
  const wrapperRef = useRef(null)
  const canvasRef = useRef(null)
  const [token, setToken] = useState('')
  const [canvasSize, setCanvasSize] = useState({ width: 500, height: 300 })
  const [isDrawing, setIsDrawing] = useState(false)
  const [lastPos, setLastPos] = useState({ x: 0, y: 0 })
  const [name, setName] = useState('')
  const [lastname, setLastname] = useState('')
  const [note, setNote] = useState('')
  const [showSuccess, setShowSuccess] = useState(false);
  const [acceptGoodsObjects] = useState(initialObjects)
  const [isSignatureDrawn, setIsSignatureDrawn] = useState(false)

  // — Responsive canvas boyutu ayarı —
  useEffect(() => {
    const resize = () => {
      if (!wrapperRef.current) return
      const w = Math.min(wrapperRef.current.clientWidth, 500)
      setCanvasSize({ width: w, height: (w * 300) / 500 })
    }
    window.addEventListener('resize', resize)
    resize()
    return () => window.removeEventListener('resize', resize)
  }, [])

  // — Token al —
  function getToken() {
    Services.GetToken().then((res) => {
      if (res.data.status) setToken(res.data.result.token)
    })
  }
  useEffect(() => {
    getToken()
  }, [])

  // — Çizim işlevleri —
  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return
    const ctx = canvas.getContext('2d')
    ctx.strokeStyle = '#000'
    ctx.lineWidth = 2

    const getPos = e => {
      const r = canvas.getBoundingClientRect()
      return {
        x: (e.clientX - r.left) * (canvas.width / r.width),
        y: (e.clientY - r.top) * (canvas.height / r.height),
      }
    }

    const onDown = e => {
      setIsDrawing(true)
      setLastPos(getPos(e))
    }
    const onMove = e => {
      if (!isDrawing) return
      setIsSignatureDrawn(true)
      const { x, y } = getPos(e)
      ctx.beginPath()
      ctx.moveTo(lastPos.x, lastPos.y)
      ctx.lineTo(x, y)
      ctx.stroke()
      setLastPos({ x, y })
    }
    const onUp = () => setIsDrawing(false)

    canvas.addEventListener('mousedown', onDown)
    canvas.addEventListener('mousemove', onMove)
    window.addEventListener('mouseup', onUp)
    return () => {
      canvas.removeEventListener('mousedown', onDown)
      canvas.removeEventListener('mousemove', onMove)
      window.removeEventListener('mouseup', onUp)
    }
  }, [isDrawing, lastPos])

  // — Canvas’ı temizle —
  const clearCanvas = () => {
    const c = canvasRef.current
    c.getContext('2d').clearRect(0, 0, c.width, c.height)
    setIsSignatureDrawn(false)
  }

  // — dataURL’den dosya ve uzantı ayrıştırma —
  const parseDataUrl = dataUrl => {
    const m = dataUrl.match(/^data:(.+?)\/(.+?);base64,(.+)$/)
    if (!m) throw new Error('Geçersiz data URL')
    return {
      file: m[3],          // base64 string
      extension: m[2],     // "png"
    }
  }

  // — İmzayı kaydet ve servisleri çağır —
  const saveSignature = async () => {
    try {
      const c = canvasRef.current
      const dataUrl = c.toDataURL('image/png')
      const signature = parseDataUrl(dataUrl)

      // 1) Handover servisine imzayı { file: base64, extension: "png" } formatında gönder
      const res1 = await Services.CreateHandoverWithSign(
        token,
        qrIds,
        name,
        lastname,
        signature,
        note?.toUpperCase()
      )
      if (!res1.data.status) throw new Error('Handover işlemi başarısız')
      else {
        clearCanvas()
        setName("")
        setLastname("")
        setNote("")
        setShowSuccess(true)
      }
      console.log(res1.data)
    } catch (err) {
      console.error(err)
      alert('Hata: ' + err.message)
    }
  }



  return (
    <Box>
      {/* Header */}
      <AppBar position="static" sx={{ bgcolor: '#003366' }}>
        <Toolbar sx={{ justifyContent: 'center' }}>
          <Box component="img" src={logo} alt="Logo" sx={{ height: 60 }} />
        </Toolbar>
      </AppBar>

      {showSuccess ?
        <Container maxWidth="sm" sx={{ py: 4 }}>

          <Typography fontSize="16px" fontWeight="600" gutterBottom>
            Mal Kabul Teslimi
          </Typography>
          <Divider />

          {/* Başarı Mesajı Kutusu */}
          <Box
            sx={{
              mt: 4,
              p: 4,
              textAlign: 'center',
              border: '1px solid #E0E0E0',
              borderRadius: '12px',
              boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
            }}
          >
            <Box
              sx={{
                width: 64,
                height: 64,
                backgroundColor: '#34A853',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 'auto',
                mb: 2,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="55"
                viewBox="0 -960 960 960"
                width="55"
                fill="#fff"
              >
                <path d="M421-316 232-505l43-43 146 146 264-264 43 43-307 307Z" />
              </svg>
            </Box>
            <Typography fontSize="16px" fontWeight="400">
              İşleminiz Başarıyla Tamamlandı.
            </Typography>
          </Box>
        </Container>
        :
        <Container maxWidth="sm" sx={{ py: 4 }}>
          <Typography fontSize="16px" fontWeight="600" gutterBottom>
            Mal Kabul Teslimi
          </Typography>
          <Divider />

          {/* Form */}
          <Box sx={{ mt: 3 }}>
            <Typography fontSize="12px" fontWeight="600">
              Teslim Alan
            </Typography>
            <TextField
              label="İsim"
              fullWidth
              margin="normal"
              value={name}
              onChange={e => setName(e.target.value)}
            />
            <TextField
              label="Soyisim"
              fullWidth
              margin="normal"
              value={lastname}
              onChange={e => setLastname(e.target.value)}
            />
            <TextField
              label="Plaka"
              fullWidth
              margin="normal"
              value={note}
              onChange={e => setNote(e.target.value)}
            />
          </Box>

          {/* İmza Alanı */}
          <Box sx={{ mt: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Typography fontSize="12px" fontWeight="600">
                Dijital İmza Alanı
              </Typography>
              <TbEdit style={{ marginLeft: 8 }} />
            </Box>
            <Box
              ref={wrapperRef}
              sx={{
                border: '1px solid #ccc',
                cursor: 'crosshair',
              }}
            >
              <canvas
                ref={canvasRef}
                width={canvasSize.width}
                height={canvasSize.height}
                style={{ width: '100%', height: 'auto' }}
              />
            </Box>
          </Box>

          {/* Butonlar */}
          <Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={clearCanvas}
              sx={{ textTransform: 'none', color: '#003366', borderColor: '#003366' }}
            >
              İmzayı Temizle
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={saveSignature}
              disabled={!name || !lastname || !note || !isSignatureDrawn}
              sx={{ textTransform: 'none', backgroundColor: '#003366' }}
            >
              Onayla
            </Button>
          </Box>
        </Container>
      }

    </Box>
  )
}

export default MalKabulTeslimi